import { CheckCircle2 } from "lucide-react";

const PreCheckFormSuccess = () => {
    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
            <div className="max-w-md w-full bg-white shadow-xl rounded-2xl p-8 text-center">

                {/* Success Icon */}
                <div className="flex justify-center mb-6">
                    <div className="w-16 h-16 flex items-center justify-center rounded-full bg-green-100">
                        <CheckCircle2 className="w-8 h-8 text-green-600" />
                    </div>
                </div>

                {/* Title */}
                <h1 className="text-2xl font-semibold text-gray-900 mb-2">
                    You're All Set
                </h1>

                {/* Description */}
                <p className="text-gray-600 mb-6">
                    Your identity verification has been successfully completed and submitted for review.
                </p>

                {/* Info Box */}
                <div className="bg-gray-100 rounded-lg p-4 text-sm text-gray-700 mb-6">
                    You can safely close this screen.
                    We’ll notify you once the review process is complete.
                </div>

                {/* Subtle hint */}
                <p className="text-xs text-gray-400">
                    This window can now be closed.
                </p>
            </div>
        </div>
    );
};

export default PreCheckFormSuccess
